export const BRANDING = import.meta.env.VITE_BRANDING;
export const BRANDING_URL = import.meta.env.VITE_BRANDING_IMAGES_URL;

export const isNommi = BRANDING === 'nommi';
export const isCakto = BRANDING === 'cakto';

export const getLabel = {
    brandName: () => (isNommi ? 'Nommi' : 'Cakto'),
    phone: () => (isNommi ? 'Celular com DDD' : 'Celular'),
};